import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { Injectable } from '@angular/core';

import { mergeApiRequests } from '@app/core/utilities/api.utilities';
import { assertArray } from '@app/core/utilities/array.utilities';
import { AccountApiRoute, ApiEndpoint, ApiGetListRequest } from '../models/api.models';
import { Account } from '../models/common.models';
import { ApiInstanceService } from './api-instance.service';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class AccountsApiService extends ApiInstanceService {
  readonly endpoint = ApiEndpoint.Accounts;

  constructor(api: ApiService) {
    super(api);
  }

  getAllAccounts(customerId: number, req?: Partial<ApiGetListRequest<Account>>): Observable<Account[]> {
    return this.getAll<Account>(
      mergeApiRequests(
        {
          endpoint: ApiEndpoint.Accounts,
          filterValues: { customerId },
        },
        req || {},
        true,
      ),
    );
  }

  getAccountById(accountId: string): Observable<Account | undefined> {
    return this.getObject<Account>({ route: accountId }).pipe(
      map((response: any) => ({
        accountId: response.data.accountId.toString(),
        adspertId: response.data.adspertAccountId,
        adspertAccountId: response.data.adspertAccountId,
        accountName: response.data.accountName,
        customerId: response.data.customerId,
        customerName: response.data.customerName,
        connectedAt: !response.data.connectedAt ? null : new Date(response.data.connectedAt),
        currency: response.data.currency,
        amzHasMWS: !!response.data.amzHasMwsAccess,
        amzAccountType: response.data.amzAccountType,
        amzRegion: response.data.amzRegion,
        optimizationStart: !response.data.optimizationStart ? null : new Date(response.data.optimizationStart),
        platform: response.data.platform,
        signupCompleted: response.data.signupCompleted,
        tags: {
          user: response.data.tagsUser,
          system: response.data.tagsSystem,
        },
      })),
      catchError(() => of(undefined)),
    );
  }

  cancelAccountMove(adspertAccountIds: number | number[], customerId: number): Observable<unknown> {
    adspertAccountIds = assertArray(adspertAccountIds);

    return this.post({
      route: [AccountApiRoute.Move],
      data: { customerId, adspertAccountIds },
    });
  }
}
